import { createContext, useContext } from 'react';

interface OpportunitiesContextType {
  count: number;
  setCount: (count: number) => void;
  refreshCount: () => Promise<void>;
}

const OpportunitiesContext = createContext<OpportunitiesContextType | undefined>(undefined);

const fallbackContext: OpportunitiesContextType = {
  count: 0,
  setCount: () => {},
  refreshCount: async () => {},
};

export function useOpportunitiesCount() {
  const context = useContext(OpportunitiesContext);
  if (!context) {
    return fallbackContext;
  }
  return context;
}
